import type { FC } from 'react';
import type { AuditLogDealInformation, IDetailedAuditLog, IDealChangeRecord } from '@makemydeal/dr-platform-types';
import VersionList from './Tables/VersionList';
import VersionCard from './Cards/VersionCard.interstate';
import { useInfiniteScroll, useIsMobile, useLazyRender } from '../hooks/customHooks';
import { CHUNK_SIZE } from '../types/AuditLog';

interface AuditLogLayoutProps {
    dealVersions: AuditLogDealInformation[];
    dealChangeLog: IDetailedAuditLog[];
    handleSetSlideoutProps: (selectedItem: IDealChangeRecord) => void;
}

/**
 * AuditLogLayout component handles the rendering logic for audit log views.
 * It manages lazy rendering and conditionally displays either mobile (VersionCard)
 * or desktop (VersionList) views based on screen size.
 */
const AuditLogLayout: FC<AuditLogLayoutProps> = ({ dealVersions, dealChangeLog, handleSetSlideoutProps }) => {
    const chunkSize = CHUNK_SIZE;
    const isMobile = useIsMobile();
    const { visibleItems, loadMore } = useLazyRender(dealVersions, chunkSize);
    const lastItemRef = useInfiniteScroll(loadMore);

    if (isMobile) {
        return <VersionCard versionData={visibleItems} changeLogData={dealChangeLog} lastItemRef={lastItemRef} />;
    }

    return (
        <VersionList
            versionData={visibleItems}
            changeLogData={dealChangeLog}
            lastItemRef={lastItemRef}
            handleSetSlideoutProps={handleSetSlideoutProps}
        />
    );
};

export default AuditLogLayout;
